import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { googleSession, LEGAL_ACCEPT_KEY } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Handles the return from Emergent-managed Google Auth: `#session_id=...`.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(
      location.hash.replace(/^#/, ""),
    ).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const accepted = sessionStorage.getItem(LEGAL_ACCEPT_KEY) === "1";
        sessionStorage.removeItem(LEGAL_ACCEPT_KEY);
        const data = await googleSession(sessionId, accepted);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="flex min-h-screen items-center justify-center gap-2 text-sm text-muted-foreground"
    >
      <Loader2 className="h-4 w-4 animate-spin" /> {t("authCallback.signingIn")}
    </div>
  );
}
